export default "__VITE_ASSET__BnVvJomk__"